import {
  EmployeeStatus,
  TEmployeesMainScreenRow,
} from '@westondev/tableturn-core';
import { ParseKeys } from 'i18next';

type SomeEmployeeStatus = EmployeeStatus.ClockIn | EmployeeStatus.ClockOut;

export const EMPLOYEE_STATUS_FILTERS_TEXT: Record<
  SomeEmployeeStatus,
  ParseKeys
> = {
  [EmployeeStatus.ClockIn]:
    'managementModule.employeesScreen.topBar.filters.status.clockedIn',
  [EmployeeStatus.ClockOut]:
    'managementModule.employeesScreen.topBar.filters.status.clockedOut',
};

export type TEmployeesMainScreenTableRow = TEmployeesMainScreenRow & {
  id: number;
  role: string;
  actions: string;
};
